export function DemoVideoVeil() {
  return (
    <div
      data-demo-video-veil
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 z-[1] bg-[linear-gradient(135deg,rgb(var(--theme-primary)/0.06),rgb(var(--theme-secondary)/0.045))]"
    />
  );
}
